export const MARKER_TYPE_TEXT = 'text';
export const MARKER_TYPE_GRAPHIC = 'graphic';
